import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

import type { ICreatePayload } from '@app/dashboard/types/innerLayout/settings/api_keys';

export const getApiKey = () => {
  return axiosPrivate.get(`/dashboard/api/v1/auth_keys`);
};

export const getPublicSecretKey = () => {
  return axiosPrivate.get(`/dashboard/api/v1/keys`);
};

export const getHmacKey = () => {
  return axiosPrivate.get(`/dashboard/api/v1/hmac_secret/get_hmac`);
};

export const createRevokeApiKey = () => {
  return axiosPrivate.get(`/dashboard/api/v1/auth_keys/renew`);
};

export const createRevokePublicSecretKey = ({
  type,
  payload,
}: {
  type: 'secret' | 'public';
  payload: ICreatePayload;
}) => {
  return axiosPrivate.post(`/dashboard/api/v1/keys/${type}`, payload);
};
